module.exports = "<div class=\"container\"><iframe #pdfView width=\"1280\" height=\"720\" frameborder=\"0\" allowfullscreen></iframe></div>\n"